import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2D2070',
      dark: '#1a1745',
      light: '#4a35a0',
      contrastText: '#fff',
    },
    secondary: {
      main: '#667EEA',
      dark: '#4a5ec8',
      light: '#8498ee',
    },
    success: {
      main: '#4caf50',
      dark: '#2e7d32',
    },
    warning: {
      main: '#ff9800',
      dark: '#f57c00',
    },
    error: {
      main: '#f44336',
      dark: '#d32f2f',
    },
    background: {
      default: '#f5f5f5',
      paper: '#fff',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
        },
      },
    },
  },
});

export default theme;
